import { ObjectId } from "bson";
import {
  EarningRulesBlock,
  HeroBlock,
  HeroBlockLogoType,
  LoyaltyBorderStyle,
  LoyaltyElementType,
  LoyaltyPageSettings,
  PointsSummaryBlock,
  PointsSummaryButtonStyle,
  PromotionsBlock,
} from "./definition";

export function heroBlockDefault(): HeroBlock {
  return {
    id: new ObjectId().toString(),
    type: LoyaltyElementType.HERO,
    visible: true,
    copy: {
      loggedIn: { title: "", subtitle: "" },
      loggedOut: { title: "", subtitle: "" },
    },
    background: { imageUrl: "", imageOpacity: 0.7, fallbackColor: "#333333" },
    logoType: HeroBlockLogoType.COMPANY_LOGO,
  };
}

export function pointsSummaryBlockDefault(): PointsSummaryBlock {
  return {
    id: new ObjectId().toString(),
    type: LoyaltyElementType.POINTS_SUMMARY,
    visible: true,
    loggedOutContent: {
      title: "",
      titleColor: "#000000",
      body: "",
      bodyColor: "#4a4a4a",
      buttonStyle: PointsSummaryButtonStyle.FILLED,
    },
    loggedInContent: {
      title: "",
      titleColor: "#000000",
      body: "",
      bodyColor: "#4a4a4a",
      subtitle: "",
      subtitleColor: "#4a4a4a",
    },
    allTime: {
      pointsEarned: { enabled: true, color: "#4a4a4a" },
      moneySpent: { enabled: false, color: "#4a4a4a" },
      pointsSpent: { enabled: false, color: "#4a4a4a" },
    },
    pointsBalance: { color: "#000000" },
  };
}

export function promotionsBlockDefault(): PromotionsBlock {
  return {
    id: new ObjectId().toString(),
    type: LoyaltyElementType.PROMOTIONS,
    visible: true,
    title: "",
    titleColor: "#000000",
    subtitle: "",
    subtitleColor: "#4a4a4a",
    promotions: { titleColor: "#000000", contentColor: "#4a4a4a" },
    borderStyle: LoyaltyBorderStyle.BORDER,
  };
}

export function earningRulesBlockDefault(): EarningRulesBlock {
  return {
    id: new ObjectId().toString(),
    type: LoyaltyElementType.EARNING_RULES,
    visible: true,
    title: "",
    titleColor: "#000000",
    subtitle: "",
    subtitleColor: "#4a4a4a",
    borderStyle: LoyaltyBorderStyle.BORDER,
  };
}

export function createDefaultLoyaltyPageSettings(): LoyaltyPageSettings {
  return {
    blocks: [
      heroBlockDefault(),
      pointsSummaryBlockDefault(),
      promotionsBlockDefault(),
      earningRulesBlockDefault(),
    ],
  };
}
